import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[40rem] mx-auto pb-24" }
const _hoisted_2 = { class: "flex flex-col gap-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-5 mt-10 px-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-[40px] font-black text-center leading-10" }, "Work where you belong"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Explore opportunities in companies with the right culture for you")
], -1)
const _hoisted_4 = { class: "w-7 h-7 mr-1 flex items-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow text-left text-sm" }, "Where will you belong?", -1)
const _hoisted_6 = { class: "w-7 h-7 bg-light-gray-100 flex flex-col items-center justify-center rounded-md p-1 text-light-gray-200" }

import { onMounted, watch, computed } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { map } from "lodash"
  import { search, optionsOutline } from "ionicons/icons"
  import { IonContent, IonButton, IonIcon, IonNavLink, loadingController, IonInfiniteScroll, IonInfiniteScrollContent, IonPage } from "@ionic/vue"
  import SearchPage from "@/views/job-board/SearchPage.vue"
  import DisoverCard from "@/components/discover-page/DisoverCard.vue"
  import Menubar from "@/components/menuBar.vue"
  // image

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DiscoverPage',
  setup(__props) {

  const companyStore = useCompanyStore()
  const companies = computed(() => {
    return map(companyStore.companies, (obj) => ({
      slug: `/company/${obj.slug}`,
      image: obj.cover_photo ? obj.cover_photo : "",
      color: obj.brand_color,
      location: obj.location?.full_address ? obj.location.full_address : obj.location?.country ? obj.location?.country : "",
      logo: obj.logo,
      name: obj.name,
      subtext: obj.tagline,
      follows: obj.follows,
    }))
  })
  const loadData = async () => {
    companyStore.filterParams.page += 1
    companyStore.isNewState = false
  }

  const initCompanies = async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Retrieving...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    await companyStore.retrieveAllCompanies(companyStore.filterParams)
    loading.dismiss()
  }
  onMounted(async () => {
    companyStore.generateFilter(true)
    companyStore.filterParams.columns = "slug,cover_photo,logo,brand_color,name,location,tagline,follows"
  })
  watch(
    () => companyStore.filterParams,
    () => initCompanies(),
    { deep: true }
  )

return (_ctx: any,_cache: any) => {
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "ion-padding" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Menubar),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(IonNavLink), {
                "router-direction": "forward",
                component: SearchPage
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    color: "white",
                    size: "large",
                    class: "text-xl text-primary-black normal-case flex flex-row justify-between items-center gap-5"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(_unref(IonIcon), { icon: _unref(search) }, null, 8, ["icon"])
                      ]),
                      _hoisted_5,
                      _createElementVNode("span", _hoisted_6, [
                        _createVNode(_unref(IonIcon), { icon: _unref(optionsOutline) }, null, 8, ["icon"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_ion_list, { lines: "none" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companies), (company) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: company.slug
                  }, {
                    default: _withCtx(() => [
                      _createVNode(DisoverCard, {
                        detail: company,
                        "discover-type": "company"
                      }, null, 8, ["detail"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_unref(IonInfiniteScroll), {
              id: "infinite-scroll",
              threshold: "100px",
              disabled: _unref(companyStore).isLast,
              onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => (loadData()))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonInfiniteScrollContent), {
                  "loading-spinner": "bubbles",
                  "loading-text": "Loading more data..."
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})